export enum SimNao {
  FL_SIM = 'S',
  FL_NAO = 'N',
}
export class SimNaoUtils {
  static getSimNaoValue(value: boolean) {
    return value ? SimNao.FL_SIM : SimNao.FL_NAO;
  }

  static getBooleanValue(enumValue: SimNao) {
    return enumValue === SimNao.FL_SIM;
  }

  static getLabel(enumValue: SimNao) {
    return enumValue === SimNao.FL_SIM ? 'Sim' : 'Não';
  }
}
